export default function TextTooltip(props) {
    const {children} = props;

    return (
        <div className="hidden lg:block shadow absolute top-full left-1/2 transform -translate-x-1/2 mt-[12px] opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto tooltipShadow olafTooltip z-20">
            <div className="bg-white w-screen max-w-[180px] p-2.5 text-olaf-green-500 shadow">{children}</div>
            <i></i>
        </div>
    );
}
